{
  "name": "taxtank",
  "version": "0.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "lint": "ng lint",
    "e2e": "ng e2e -c local",
    "test": "ng test",
    "prod": "ng build -c production && make -f sentry/Makefile",
    "stage": "ng build -c stage && make -f sentry/Makefile",
    "dev": "ng build -c dev && make -f sentry/Makefile",
    "local:build": "ng build -c local",
    "local": "ng serve -c local",
    "watch": "node ./node_modules/@angular/cli/bin/ng serve -c local",
    "install:core": "npm install taxtank-core@latest",
    "install:core:local": "npm install file:../tt-core/dist/tt-core",
    "cypress:open": "cypress open",
    "cypress:run": "cypress run"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.1.3",
    "@angular/cdk": "^20.1.3",
    "@angular/common": "^20.1.3",
    "@angular/compiler": "^20.1.3",
    "@angular/core": "^20.1.3",
    "@angular/forms": "^20.1.3",
    "@angular/material": "^20.1.3",
    "@angular/material-luxon-adapter": "^20.1.3",
    "@angular/platform-browser": "^20.1.3",
    "@angular/platform-browser-dynamic": "^20.1.3",
    "@angular/router": "^20.1.3",
    "@auth0/angular-jwt": "^5.2.0",
    "@basiq/basiq-connect-control": "^1.0.72",
    "@e965/xlsx": "^0.20.3",
    "@fullcalendar/angular": "^6.1.19",
    "@fullcalendar/core": "^6.1.19",
    "@fullcalendar/daygrid": "^6.1.19",
    "@fullcalendar/interaction": "^6.1.19",
    "@fullcalendar/list": "^6.1.19",
    "@ng-idle/core": "^14.0.0",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^4.0.0",
    "@primeng/themes": "^20.0.1",
    "@rxweb/generics": "^0.0.1-4",
    "@rxweb/reactive-form-validators": "^13.0.1",
    "@sentry/angular": "^9.39.0",
    "@sentry/browser": "^9.39.0",
    "@sentry/cli": "^2.47.1",
    "@stripe/stripe-js": "^4.2.0",
    "@types/facebook-js-sdk": "^3.3.11",
    "@types/gapi": "^0.0.47",
    "@types/gapi.auth2": "^0.0.61",
    "@types/mixpanel-browser": "^2.49.0",
    "adblock-checker": "^0.2.4",
    "angularx-qrcode": "^20.0.0",
    "bootstrap": "^5.3.3",
    "class-transformer": "^0.5.1",
    "event-source-polyfill": "^1.0.31",
    "file-saver": "^2.0.5",
    "highcharts": "^11.4.8",
    "html2pdf.js": "^0.12.1",
    "install": "^0.13.0",
    "jspdf": "^3.0.3",
    "jspdf-autotable": "^5.0.2",
    "leaflet": "^1.9.4",
    "leaflet.markercluster": "^1.5.3",
    "lodash": "^4.17.21",
    "luxon": "^3.6.1",
    "mixpanel-browser": "^2.49.0",
    "moment": "^2.30.1",
    "moment-range": "^4.0.2",
    "moment-timezone": "^0.5.48",
    "ng2-pdf-viewer": "^10.4.0",
    "ngx-mat-select-search": "^8.0.2",
    "ngx-moment": "^6.0.2",
    "ngx-pipes": "^3.2.2",
    "ngx-ui-tour-md-menu": "^15.0.0",
    "npm": "^10.8.2",
    "primeicons": "^6.0.1",
    "primeng": "^20.4.0",
    "primeng-sass-theme": "github:primefaces/primeng-sass-theme#main",
    "rxjs": "^7.8.1",
    "swiper": "^8.4.7",
    "taxtank-core": "^2.1.14",
    "tslib": "^2.8.1",
    "zone.js": "^0.15.0"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^20.1.1",
    "@angular-eslint/eslint-plugin": "^20.1.1",
    "@angular-eslint/eslint-plugin-template": "^20.1.1",
    "@angular-eslint/schematics": "^20.1.1",
    "@angular-eslint/template-parser": "^20.1.1",
    "@angular/build": "^20.1.4",
    "@angular/cli": "^20.1.4",
    "@angular/compiler-cli": "^20.1.4",
    "@angular/language-service": "^20.1.4",
    "@angular/localize": "^20.1.4",
    "@cypress/schematic": "^1.7.0",
    "@types/cucumber": "^7.0.0",
    "@types/cypress-cucumber-preprocessor": "^4.0.5",
    "@types/file-saver": "^2.0.7",
    "@types/jasmine": "~5.1.5",
    "@types/lodash": "^4.17.13",
    "@types/node": "^22.10.2",
    "@typescript-eslint/eslint-plugin": "^8.18.2",
    "@typescript-eslint/parser": "^8.18.2",
    "@typescript-eslint/utils": "^8.18.2",
    "cucumber": "^6.0.7",
    "cypress": "^13.13.2",
    "cypress-cucumber-preprocessor": "^4.3.1",
    "cypress-file-upload": "^5.0.8",
    "eslint": "^8.57.0",
    "eslint-plugin-rxjs": "^5.0.3",
    "eslint-plugin-rxjs-angular": "^2.0.1",
    "jasmine-core": "~5.5.0",
    "jasmine-spec-reporter": "~5.0.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-coverage-istanbul-reporter": "~3.0.2",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "ts-node": "~7.0.0",
    "typescript": "^5.8.3"
  },
  "overrides": {
    "canvg": "4.0.3"
  },
  "cypress-cucumber-preprocessor": {
    "nonGlobalStepDefinitions": true
  }
}
